import { render, staticRenderFns } from "./TimeMachine.vue?vue&type=template&id=66283054&scoped=true"
import script from "./TimeMachine.vue?vue&type=script&lang=ts"
export * from "./TimeMachine.vue?vue&type=script&lang=ts"
import style0 from "./TimeMachine.vue?vue&type=style&index=0&id=66283054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66283054",
  null
  
)

export default component.exports